var ezdia;
(function (ezdia) {
    var debug = false;
    function metaObject(column) {
        var obj = {};
        var metadata = column.metadata || column.addon;
        if (!metadata) {
            return null;
        }
        if (column.edittype === 'json') {
            return metadata;
        }
        if (typeof metadata === 'string') {
            if (column.edittype === 'tab' || column.edittype === 'composite') {
                obj.fields = metadata.split(',');
            }
            else {
                $.each(metadata.split(','), function (i, mval) {
                    var temp = [];
                    var key = null;
                    var value = null;
                    if (mval.includes('##')) {
                        obj.options = {};
                        $.each(mval.split('##'), function (j, opt) {
                            var temps = opt.toLowerCase();
                            if (temps === 'other' &&
                                (column.edittype === 'singlechoice' ||
                                    column.edittype === 'multichoice')) {
                                obj.userInput = true;
                            }
                            else {
                                obj.options[opt] = opt;
                            }
                        });
                    }
                    else if (!mval.includes(':')) {
                        obj[mval] = true;
                    }
                    else {
                        temp = mval.split(':');
                        // eslint-disable-next-line prefer-destructuring
                        key = temp[0];
                        // eslint-disable-next-line prefer-destructuring
                        value = temp[1];
                        switch (key) {
                            case 'cssCls':
                                obj[key] = value;
                                break;
                            case 'rows':
                                obj[key] = value;
                                break;
                            case 'height':
                                obj[key] = value;
                                break;
                            case 'width':
                                obj[key] = value;
                                break;
                            case 'min':
                                obj[key] = value;
                                break;
                            case 'max':
                                obj[key] = value;
                                break;
                            default:
                                if (!obj[key]) {
                                    obj[key] = [];
                                }
                                obj[key].push(value);
                                break;
                        }
                    }
                });
            }
            metadata = obj;
        }
        if (debug) {
            // eslint-disable-next-line no-console
            console.log(metadata);
        }
        return metadata;
    }
    function customerConfig(config) {
        var e_1, _a;
        var json = {};
        $.each(config, function (key, value) {
            switch (key) {
                case 'charcount_min_count':
                case 'charcount_min_tooltip':
                case 'charcount_min_message':
                case 'charcount_min_type':
                case 'charcount_max_count':
                case 'charcount_max_tooltip':
                case 'charcount_max_message':
                case 'charcount_max_type':
                case 'charcount_disable':
                case 'charcount_ignore_html':
                case 'wordcount_min_count':
                case 'wordcount_min_tooltip':
                case 'wordcount_min_message':
                case 'wordcount_min_type':
                case 'wordcount_max_count':
                case 'wordcount_max_tooltip':
                case 'wordcount_max_message':
                case 'wordcount_max_type':
                case 'wordcount_disable':
                    setCustomerConfig(json, key, value);
                    delete config[key];
                    break;
                default:
                    break;
            }
        });
        if (!$.isEmptyObject(json)) {
            try {
                for (var _b = __values(Object.entries(json)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), key = _d[0], obj = _d[1];
                    config[key] = obj;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (debug) {
            // eslint-disable-next-line no-console
            console.log(config);
        }
        return config;
    }
    function setCustomerConfig(json, key, value) {
        var e_2, _a;
        var arr = key.split('_');
        var last = arr[arr.length - 1];
        try {
            for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                var name_1 = arr_1_1.value;
                name_1 = name_1.toLowerCase();
                if (typeof json[name_1] === 'undefined') {
                    if (last === name_1) {
                        json[name_1] = value;
                    }
                    else {
                        json[name_1] = {};
                    }
                }
                // eslint-disable-next-line no-param-reassign
                json = json[name_1];
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    var util;
    (function (util) {
        /**
         * This function is writen to convert old metadata to new config object.
         * Old function for this is "$.ezdia.getFieldsConfig" writen in ezdia.common.js
         * @param column {ColModel}
         */
        function getFormatedConfigObject(column) {
            var config = column.config;
            var parsedUrl = new URL(window.location.href);
            debug = parsedUrl.searchParams.get('debug');
            if (config) {
                if (typeof config === 'string' && $.trim(config)) {
                    column.config = ezdia.util.jsonParse(config);
                }
                return config;
            }
            column.config = metaObject(column);
            return column.config;
        }
        util.getFormatedConfigObject = getFormatedConfigObject;
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        function getCustomerConfig(config) {
            return customerConfig(config);
        }
        util.getCustomerConfig = getCustomerConfig;
    })(util = ezdia.util || (ezdia.util = {}));
})(ezdia || (ezdia = {}));
